import { defineMessages, IntlShape } from "react-intl";

import Role from "@mapmycustomers/shared/enum/Role";

import { getDisplayName } from "./getDisplayName";

const messages = defineMessages<Role>({
  [Role.MANAGER]: {
    id: "role.manager",
    defaultMessage: "Team manager",
    description: "Name of manager role",
  },
  [Role.MEMBER]: {
    id: "role.member",
    defaultMessage: "Team member",
    description: "Name of member role",
  },
  [Role.OWNER]: {
    id: "role.owner",
    defaultMessage: "Team Owner",
    description: "Name of owner role",
  },
  [Role.READ_ONLY]: {
    id: "role.readOnly",
    defaultMessage: "Read only",
    description: "Name of read only role",
  },
  [Role.READ_ONLY_WITH_EXPORTS]: {
    id: "role.readOnlyWithExports",
    defaultMessage: "Read only with exports",
    description: "Name of read only with exports role",
  },
});

const altMessages = defineMessages<Role>({
  [Role.MANAGER]: {
    id: "role.alternate.manager",
    defaultMessage: "Managers",
    description: "Name of manager role (alternate)",
  },
  [Role.MEMBER]: {
    id: "role.alternate.member",
    defaultMessage: "Members",
    description: "Name of member role (alternate)",
  },
  [Role.OWNER]: {
    id: "role.alternate.owner",
    defaultMessage: "Owners",
    description: "Name of owner role (alternate)",
  },
  [Role.READ_ONLY]: {
    id: "role.alternate.readOnly",
    defaultMessage: "Read only members",
    description: "Name of read only role (alternate)",
  },
  [Role.READ_ONLY_WITH_EXPORTS]: {
    id: "role.alternate.readOnlyWithExports",
    defaultMessage: "Read only with exports members",
    description: "Name of read only with exports role (alternate)",
  },
});

const getRoleDisplayName = (intl: IntlShape, role: Role) =>
  getDisplayName(intl, messages, role, "Role");

// TODO: move to settings scene
export const getRoleDisplayNameAlt = (intl: IntlShape, role: Role) =>
  getDisplayName(intl, altMessages, role, "Role");

export default getRoleDisplayName;
